<template>
  <div className="dark:bg-black">
    <!-- <div>{{ $i18n.locale = 'ru' }}</div> -->
    <!-- <a @click="showIframeModal()"> OPEN MODAL</a> -->
    <div class="modal-call">
            <div class="modal-call__content">
                <header class="modal-call__header">
                    <h2>{{  $t("CALL_TO_SUPPORT") }}</h2>
                    <button class="modal-call__close-btn iconfont-close" @click="closeForm()"></button>
                </header>
                <main class="modal-call__main" >
                    <!-- <div class="modal-call__error">
                        <p>
                            Не удалось связаться с оператором. <br />
                            Вы можете позвонить позднее или оставить текстовый запрос
                        </p>
                    </div> -->
                    <!-- .modal-call__error --><!--     ul --><!--         li Заполните имя--><!--         li Заполните фамилию--><!--         li Введите номер телефона--><!--         li Введите E-mail-->
                    <form class="modal-call__form" action="">
                        <!-- добавлять .input_error при ошибке-->
                        <div class="input" v-bind:class="nameinputclass">
                            <input id="modal-call-name" v-model="name" type="text" name="modal-call-name" placeholder="" required/><label for="modal-call-name">{{ $t("NAME") }}</label><button @click="name = ''" class="wmds-btn wmds-btn-system iconfont-cross"></button>
                        </div>
                        <div class="input" v-bind:class="phoneinputclass">
                            <input id="modal-call-phone" v-model="phone" v-maska="'# (###) ### ## ##'" type="tel" name="modal-call-phone" required placeholder=" " /><label for="modal-call-phone">{{ $t("PHONE") }}</label><button  @click="phone = ''" class="wmds-btn wmds-btn-system iconfont-cross"></button>
                        </div>
                        <div class="input" v-bind:class="emailinputclass">
                            <input id="modal-call-email" v-model="email" type="email" name="modal-call-email" required placeholder=" " /><label for="modal-call-email">E-mail</label><button @click="email = ''" class="wmds-btn wmds-btn-system iconfont-cross"></button>
                        </div>
                        <div class="input input-textarea" v-bind:class="messageinputclass"><textarea id="modal-call-message" v-model="message" name="modal-call-message" cols="30" rows="10" placeholder=" " required></textarea><label for="modal-call-message">{{  $t("THE_REASON_OF_CALL") }}</label></div>
                    </form>
                    <div class="modal-call__qr">
                        <div class="modal-call__qr-descr">
                             {{ $t('IF_NO_MIC')}} - <br />
                            {{ $t('OPEN_ON_PHONE') }}
                        </div>
                        <div class="modal-call__qr-img"><img src="../assets/images/QR.png" alt="QR-код" /></div>
                    </div>
                    <div class="modal-call__buttons">
                        <button class="modal-call__btn-cancel wmds-btn wmds-btn-xl wmds-btn-secondary-stroke" @click="closeForm()">{{ $t("CANCEL") }}</button><button @click="performCall" :disabled='isDisabled' class="modal-call__btn-next wmds-btn wmds-btn-xl wmds-btn-primary">{{ $t("CALL") }}</button>
                    </div>
                </main>
            </div>
        </div>
      <!-- <a @click="$i18n.locale = 'ru'">Rus</a>
      <a @click="$i18n.locale = 'en'">eng</a> -->
      <!-- <br>
      <a @click="setLang()">LOC</a> -->
      <fwb-modal v-if="isShowModalIframe" @close="closeModal2()" size="5xl" persistent>
        <template #header>
          <div class="flex items-center text-lg" style="color:white;">
            {{ $t("CALLING") }}
          </div>
          <div style="color:white;cursor:pointer;" @click="closeModal2()">
            &#10005;
          </div>
        </template>
        <template #body >
          <div>
            <iframe allowusermedia v-if="!showcallended" v-bind:src="iframurl" style="width:100%;min-height: 400px;" allow="camera *;microphone *; display-capture *; autoplay *; clipboard-write *; fullscreen *;"></iframe>

          </div>
          <div v-if="showcallended">
            <h1 class="endtext">{{ $t("CALL_IS_OVER") }}</h1>
          </div>
        </template>
      </fwb-modal>
    <!-- <div class="buttoncontainer">
      <a href="#" class="button" @click="showModal">
        Call
      </a>
      <fwb-modal v-if="isShowModal" @close="closeModal" persistent>
        <template #header>
          <div class="flex items-center text-lg" style="color:white;">
            Заполнить поля ниже
          </div>
          <div style="color:white;cursor:pointer;" @click="isShowModal = !isShowModal">
            &#10005;
          </div>
        </template>

        <template #body >
          <div class="modalcontainer" v-if="!showloader">
            <div>
              <input v-model="name" placeholder="Укажите Имя" />
            </div>
            <div>
              <input v-model="secondname" placeholder="Укажите Фамилию" />
            </div>
            <div>
              <input v-model="phone" placeholder="Укажите номер телефона" />
            </div>
            <div>
              <input v-model="email" placeholder="Укажите email" />
            </div>
            <div>
              <textarea v-model="message" placeholder="Укажите причину обращения"></textarea>
            </div>
            <div>
              <a href="#" class="buttongreen" @click="performCall">
                Позвонить
              </a>
            </div>
          </div>
          <div class="loader-container" v-if="showloader">
            <div class="loader">
            </div>
          </div>
        </template>
      </fwb-modal>
      
    </div> -->
  </div>

  
 </template>
 
 <script>
//  import { onMounted } from 'vue';
// import VueCookies from 'vue-cookies'

// import Cookies from 'cookies';
 //import { CAlert } from '@coreui/vue';
//  import ModalWindow from './ModalWindow'
//  import { ModalsContainer } from 'vue-final-modal'

 import { ref } from 'vue'
 import VueCookies from 'vue-cookies'
 import { FwbModal } from 'flowbite-vue'
 import { createContactAndCall, resetCall } from '../services/api'
 import { maska } from 'maska'
 import socketioservice from '../services/socketioservice';
//  import test from "../services/const";

//  import ModalConfirm from './ModalConfirm.vue'
 export default {
   name: 'HomePlace',
   props: {
     msg: String,
   },
   components: {
    FwbModal
   },
   methods: {

    setLang(){
      if(this.$route.query){
        if(this.$route.query.lang){
          this.$i18n.locale = this.$route.query.lang;
        }
      }
      // $i18n.locale = lang;
    },

    playWaitingAudio(){
      if(this.audio){
        this.audio.play();
      }else{
        this.audio = new Audio('/waiting.wav'); // path to file
        this.audio.loop = true;
        this.audio.play();
      }
    },

    stopPlayAudio(){
      console.log("Stopping play ringtone audio");
      if(this.audio){
        console.log(this.audio);
        this.audio.pause();
      }
    },
    showIframeModal(){
      this.isShowModalIframe = true;
    },
    closeModal2(){
      this.sendReject()
      this.name = null;
      this.email = null;
      this.message = null;
      this.phone = null;
      if (this.audio){
	this.audio.pause()
      }
    },

    showModal() {
      alert(1);
      this.isShowModal = true
      let message ={
          command: "openSupportCallWindow"
        }
      if(window.parent){
        window.parent.postMessage(message, '*');
      }
    },
    closeModal(){
      this.isShowModal = false
      let message ={
          command: "openSupportCallWindow"
        }
      if(window.parent){
        window.parent.postMessage(message, '*');
      }
    },

    closeForm(){
      let message ={
          command: "closeSupportCallWindow"
        }
      if(window.parent){
        window.parent.postMessage(message, '*');
      } 
    },
    sendReject(){
      resetCall(this.callrequestid,this.callerid).then((res) => {
        this.isShowModalIframe = false;
      })
    },
    logData(){
      console.log(this.surname);
    },
    onclose(){
      alert('close');
    },
    socketListener(){
      socketioservice.socket.on("connect", ()=>{
        this.socketconnected = true;
      })
      socketioservice.socket.on("stopAudioPlay", (msg)=>{
        this.stopPlayAudio()
      })
      socketioservice.socket.on("closeCall", (msg) => {
        if(msg.id){
          if(msg.id == this.currentcallid){
            this.currentcallid = null;
            // this.closeModal2()
            this.iframurl = null;
            this.showcallended = true;
            this.stopPlayAudio()
          }
        }
      })
    },
    sendSocketCallRequestSubscription(tk){
      console.log(tk)
      let dd = {}
      dd['token'] = tk;
      socketioservice.socket.emit("subscribeCallRequestEvents", dd);
    },
    
    
    setValuesFromLocalStorage(){
      this.name = localStorage.getItem("supportform-name");
      this.phone = localStorage.getItem("supportform-phone");
      this.email = localStorage.getItem("supportform-email");
      this.message = localStorage.getItem("supportform-message");
    },
         


    performCall(){
      this.nameinputclass =null;
      this.messageinputclass = null;
      this.emailinputclass = null;
      this.phoneinputclass = null;

      if(this.name == null){
        this.nameinputclass = 'input_error';
        return
      }
      if(this.phone == null){
        this.phoneinputclass = 'input_error'
        return
      }
      if(this.email == null){
        this.emailinputclass = 'input_error'
        return
      }
      let myphone = this.phone.replace(/\s/g, '').replace("(", '').replace(")",'')
      
      if(/^[a-zа-я ,.'-]+$/i.test(this.name) != true){
        this.nameinputclass = 'input_error';
        return
      }
      if(/^[0-9]{5,12}$/i.test(myphone) != true){
        this.phoneinputclass = 'input_error';
        return
      }

      if(/^[^\s@]+@[^\s@]+\.[^\s@]+$/i.test(this.email) != true){
        console.log("Email err")
        this.emailinputclass = 'input_error';
        return
      }
      
      let data = {}
      data['name'] = this.name;
      data['secondname'] = this.secondname;
      data['phone'] = myphone;
      data['email'] = this.email;
      data['message'] = this.message;

      localStorage.setItem("supportform-name", this.name)
      localStorage.setItem("supportform-phone", myphone)
      localStorage.setItem("supportform-email", this.email)
      localStorage.setItem("supportform-message", this.message)



      this.showloader = true;
      this.showcallended = false;
      
      
      // this.iframurl = "https://videochat.webmoney.com/?design=dark&roomid=" + '2111212';
      // this.showIframeModal();
      
      this.isDisabled = true
      createContactAndCall(data).then((res) => {
        this.isDisabled  = false
        let message ={
          command: "openSupportCallWindow"
        }
        if(window.parent){
          window.parent.postMessage(message, '*');
        }
        console.log("------------------------ ", res);
        var domain = 'webmoney.com';
        if(window.location.href.indexOf("web.money") > -1){
          domain = 'web.money';
        }
        VueCookies.set('client', res.authdata.chattoken.client, '1d', '/', "." + domain, true, 'None')
        VueCookies.set('expiry', res.authdata.chattoken.expiry, '1d', '/', "." + domain, true, 'None')
        VueCookies.set('access-token', res.authdata.chattoken.token, '1d', '/', "." + domain, true, 'None')
        VueCookies.set('uid', res.authdata.uid, '1d', '/', "." + domain, true, 'None')
        VueCookies.set('token-type', 'Bearer', '1d', '/', "." + domain, true, 'None')
        
        if(res.roomid){
          this.currentcallid = res.id;
          this.callrequestid = res.id;
          this.callerid = res.caller_id;
          this.iframurl = "https://videochat."+domain+"/?supportcall=true&design=dark&roomid=" + res.roomid;
          this.showIframeModal();
          this.sendSocketCallRequestSubscription(res.sockettoken)
          this.playWaitingAudio();
          setTimeout(() =>{
            this.showloader = false
          }, 500)
        }
      })
    }
   },
   data(){
    return {
      isShowModal: false,
      isShowModalIframe: false,
      showloader: false,
      secondname: null,
      name: null,
      phone: null,
      email: null,
      message: null,
      iframurl: null,
      callrequestid: null,
      callerid: null,
      nameinputclass: null,
      messageinputclass: null,
      emailinputclass: null,
      phoneinputclass: null,
      currentcallid: null,
      showcallended: false,
      audio: '',
      isDisabled: false

    }
   },
   mounted() {
    // const $cookies = inject<VueCookies>('$cookies'); 
    // alert($cookies.get("ttp"));
    // alert(VueCookies.get("ttp"));
    // VueCookies.set("token-type", "Bearer");
    // alert('1')
    this.socketListener();
    this.setLang();
    this.setValuesFromLocalStorage();
   }
 }
 
 </script>
 
 <!-- Add "scoped" attribute to limit CSS to this component only -->
 <style scoped>
 .loader-container{
  display: flex;
  justify-content: center;
 }
 
 .endtext{
    color:white;
 }
 .loader {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        position: relative;
        animation: rotate 1s linear infinite
      }
      .loader::before , .loader::after {
        content: "";
        box-sizing: border-box;
        position: absolute;
        inset: 0px;
        border-radius: 50%;
        border: 5px solid #FFF;
        animation: prixClipFix 2s linear infinite ;
      }
      .loader::after{
        border-color: #FF3D00;
        animation: prixClipFix 2s linear infinite , rotate 0.5s linear infinite reverse;
        inset: 6px;
      }

      @keyframes rotate {
        0%   {transform: rotate(0deg)}
        100%   {transform: rotate(360deg)}
      }

      @keyframes prixClipFix {
          0%   {clip-path:polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)}
          25%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 0,100% 0,100% 0)}
          50%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,100% 100%,100% 100%)}
          75%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 100%)}
          100% {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 0)}
      }
 .modalcontainer{
  display: flex;
  justify-content: center;
  flex-direction: column;
 }
 .modalcontainer input{
  margin-top:10px;
  padding:10px;
  width:80%;
 }
 .modalcontainer textarea{
  margin-top:40px;
  padding:10px;
  width:80%;
  margin-bottom: 20px;;
 }
 h3 {
   margin: 40px 0 0;
 }
 ul {
   list-style-type: none;
   padding: 0;
 }
 li {
   display: inline-block;
   margin: 0 10px;
 }
 a {
   color: #42b983;
 }
 .button {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 14px;
  background-image: linear-gradient(#3470fa, #313ed7);
  color: white;
  border: solid 2px #0618db;
  height: 50px;
  padding: 0px 20px;
  border-radius: 5px;
  font-weight: 600;
  transform: scale(0.89);
  position: relative;
}
.buttongreen{
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 14px;
  background-image: linear-gradient(#81FBB8, #28C76F);
  color: white;
  border: solid 2px #42b983;
  height: 50px;
  padding: 0px 20px;
  border-radius: 5px;
  font-weight: 600;
  transform: scale(0.89);
  position: relative;

}
.button:not(:hover) .hide,
.button:not(:hover) .icon::before,
.button:not(:hover) .icon::after {
  opacity: 0;
  visibility: hidden;
  transform: scale(1.4);
}
.hide {
  transition: all 0.2s ease;
}
.button:active {
  background-image: linear-gradient(#313ed7, #3470fa);
  border-color: #313ed7;
}
.icon {
  position: relative;
}
.icon::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 6px;
  height: 6px;
  transform: translate(-50%, -50%);
  background-color: rgb(255, 0, 170);
  border-radius: 100%;
}
.icon::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  transform: translate(-19%, -60%);
  width: 100px;
  height: 33px;
  background-color: transparent;
  border-radius: 12px 22px 2px 2px;
  border-right: solid 2px rgb(255, 0, 170);
  border-top: solid 2px transparent;
}
.icon .text-icon {
  color: rgb(255, 0, 170);
  position: absolute;
  font-size: 12px;
  left: -37px;
  top: -38px;
}
.icon svg {
  width: 20px;
  height: 20px;
  border: solid 2px transparent;
  display: flex;
}
.button:hover .icon svg {
  border: solid 2px rgba(255, 0, 170, 0.692);
}
.padding-left {
  position: absolute;
  width: 20px;
  height: 2px;
  background-color: rgb(255, 0, 170);
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
.padding-left:before {
  content: "";
  width: 2px;
  height: 10px;
  background-color: rgb(255, 0, 170);
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
.padding-left:after {
  content: "";
  width: 2px;
  height: 10px;
  background-color: rgb(255, 0, 170);
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
.padding-left-line {
  position: absolute;
  width: 30px;
  height: 2px;
  background-color: rgb(255, 0, 170);
  left: -24px;
  top: 11px;
  transform: rotate(-50deg);
}
.padding-left-line::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 6px;
  height: 6px;
  transform: translate(-50%, -50%);
  background-color: rgb(255, 0, 170);
  border-radius: 100%;
}
.padding-left-text {
  color: rgb(255, 0, 170);
  font-size: 12px;
  position: absolute;
  white-space: nowrap;
  transform: rotate(50deg);
  bottom: 30px;
  left: -67px;
}

.padding-right {
  position: absolute;
  width: 20px;
  height: 2px;
  background-color: rgb(255, 0, 170);
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
.padding-right:before {
  content: "";
  width: 2px;
  height: 10px;
  background-color: rgb(255, 0, 170);
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
.padding-right:after {
  content: "";
  width: 2px;
  height: 10px;
  background-color: rgb(255, 0, 170);
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
.padding-right-line {
  position: absolute;
  width: 30px;
  height: 2px;
  background-color: rgb(255, 0, 170);
  right: -24px;
  top: 11px;
  transform: rotate(50deg);
}
.padding-right-line::before {
  content: "";
  position: absolute;
  left: 30px;
  top: 0;
  width: 6px;
  height: 6px;
  transform: translate(-50%, -50%);
  background-color: rgb(255, 0, 170);
  border-radius: 100%;
}
.padding-right-text {
  color: rgb(255, 0, 170);
  font-size: 12px;
  position: absolute;
  white-space: nowrap;
  transform: rotate(-50deg);
  bottom: 33px;
  left: 18px;
}
.background {
  position: absolute;
}
.background::before {
  content: "";
  position: absolute;
  right: 27px;
  bottom: -70px;
  width: 100px;
  height: 53px;
  background-color: transparent;
  border-radius: 0px 0px 22px 22px;
  border-right: solid 2px rgb(255, 0, 170);
  border-bottom: solid 2px transparent;
}
.background::after {
  content: "";
  position: absolute;
  right: 25px;
  bottom: -20px;
  width: 6px;
  height: 6px;
  background-color: rgb(255, 0, 170);
  border-radius: 100%;
}
.background-text {
  position: absolute;
  color: rgb(255, 0, 170);
  font-size: 12px;
  bottom: -70px;
  left: -115px;
}
.border {
  position: absolute;
  right: 0;
  top: 0;
}
.border:before {
  content: "";
  width: 15px;
  height: 15px;
  border: solid 2px rgb(255, 0, 170);
  position: absolute;
  right: 0%;
  top: 0;
  transform: translate(50%, -50%);
  border-radius: 100%;
}
.border:after {
  content: "";
  width: 2px;
  height: 25px;
  background-color: rgb(255, 0, 170);
  position: absolute;
  right: -10px;
  top: -15px;
  transform: translate(50%, -50%) rotate(60deg);
}
.border .border-text {
  position: absolute;
  color: rgb(255, 0, 170);
  font-size: 12px;
  right: -112px;
  top: -30px;
  white-space: nowrap;
}

.buttoncontainer{
  display: flex;
  justify-content: center;

}
 </style>